import React, { useReducer } from 'react';
import { MaintenancePackageContext } from './maintenancePackageContext';
import MaintenancePackageReducer from './maintenancePackageReducer';
import { DEFAULT_MAINTENANCE_PACKAGE_STATE } from './constants/defaultState';
import { clearState, setLoading } from '../utils';
import { IMaintenancePackageState } from './types';
import { IFiltersMaintenancePackages } from 'src/components/MaintenancePackages/Filters/components/types';
import {
    searchMaintenancePackagesByFilters,
    updateMaintenancePackageById,
    createMaintenancePackage,
    getMaintenancePackageById,
    deleteMaintenancePackageById,
    bulkDeleteMaintenancePackages,
} from './utils';
import { TAPIOptions } from 'src/constants/apis/types';
import { IMaintenancePackage } from 'src/interfaces/maintenancePackage';
import { TBulkDeleteFilter } from 'src/interfaces/TBulkDeleteFilter';

export const MaintenancePackageState = ({
    children,
}: IMaintenancePackageState) => {
    const [state, dispatch] = useReducer(
        MaintenancePackageReducer,
        DEFAULT_MAINTENANCE_PACKAGE_STATE
    );

    return (
        <MaintenancePackageContext.Provider
            value={{
                ...state,
                clearState: () =>
                    clearState(dispatch, {
                        maintenancePackages: null,
                        maintenancePackage: null,
                        total: 0,
                        loading: false,
                        error: null,
                        success: null,
                    }),
                setLoading: () => setLoading(dispatch),
                searchMaintenancePackagesByFilters: (
                    values: IFiltersMaintenancePackages,
                    options?: TAPIOptions
                ) =>
                    searchMaintenancePackagesByFilters(
                        dispatch,
                        values,
                        options
                    ),
                getMaintenancePackageById: (
                    id: string,
                    options?: TAPIOptions
                ) => getMaintenancePackageById(dispatch, id, options),
                updateMaintenancePackageById: (
                    id: string,
                    values: Partial<IMaintenancePackage>,
                    options?: TAPIOptions
                ) =>
                    updateMaintenancePackageById(dispatch, id, values, options),
                createMaintenancePackage: (
                    values: Partial<IMaintenancePackage>,
                    options?: TAPIOptions
                ): Promise<Partial<IMaintenancePackage> | undefined> =>
                    createMaintenancePackage(dispatch, values, options),
                deleteMaintenancePackageById: (id: string) =>
                    deleteMaintenancePackageById(dispatch, id),
                bulkDeleteMaintenancePackages: (
                    values: TBulkDeleteFilter,
                    callback: Function
                ) => bulkDeleteMaintenancePackages(dispatch, values, callback),
            }}
        >
            {children}
        </MaintenancePackageContext.Provider>
    );
};
